import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  create(params: ProviderIos.Create.In) {
    return this.provider.create(params);
  }

  updateServices(params: ProviderIos.UpdateServices.In) {
    return this.provider.updateServices(params);
  }

  update(params: ProviderIos.Update.In) {
    return this.provider.update(params);
  }

  delete(params: ProviderIos.Delete.In) {
    return this.provider.delete(params);
  }

  specifyPayment(params: ProviderIos.SpecifyPayment.In) {
    return this.provider.specifyPayment(params);
  }

  get(params: ProviderIos.Get.In) {
    return this.provider.get(params);
  }

  getMany(params: ProviderIos.Common.In) {
    return this.provider.getMany(params);
  }

  changeStatus(params: ProviderIos.ChangeStatus.In) {
    return this.provider.changeStatus(params);
  }

  getPaginated(params: ProviderIos.GetPaginated.In) {
    return this.provider.getPaginated(params);
  }
}

export { Service };
